import { httpRequest } from "../../../utils/HttpRequest";
import { ISearchPage, IPage, IMdCmFields, ISearchPageField } from "@/types/FmsTypes";
import { LONG_REQUEST_TIMEOUT } from "@/utils/constants";

//详情
export interface IPaymentDetail {
    id: string,
    shopCode: string;//门店编码
    shopName: string;//门店名称
    partnerCode: string;//客户、供应商编码
    partnerName: string;//客户、供应商名称
    code: string;//账户编码
    name: string;//账户名称
    usedAmount: number;//账户挂账金额
    sumAmount: number;//未核销单据金额
    diffAmount: number;//差异金额
}


//搜索条件
export interface IPaymentSearchFields extends Partial<IPaymentDetail>{

}

export interface IPaymentSearch
    extends IPaymentSearchFields, ISearchPage,ISearchPageField {
}

export interface IPaymentStatistics{
    diffAmount: number;
}

class PaymentService {
    async page(searchVo: IPaymentSearch) {
        const apiUrl = "/paymentMonitoring/pg";
        return await httpRequest.post<IPage<IPaymentDetail>>(apiUrl, searchVo);
    }
    async statistics(searchVo: IPaymentSearch) {
        const apiUrl = "/paymentMonitoring/statistics";
        return await httpRequest.post<IPaymentStatistics>(apiUrl, searchVo);
    }
    //导出
    async export(searchVo: IPaymentSearchFields) {
        const apiUrl = "/paymentMonitoring/export";
        return await httpRequest.postFile<boolean>(apiUrl, searchVo, { timeout: LONG_REQUEST_TIMEOUT });
    }
}

export const paymentService = new PaymentService();
